import { createUseStyles } from 'react-jss'

import { COLOR, MQ } from 'utils/constants'

export const useStyles = createUseStyles({
  wrapper: {
    padding: [0, 0, 70],
    background: COLOR.OFF_WHITE,
    [MQ.TABLET]: {
      padding: [20, 0, 125],
    },
  },
})
